import { render, staticRenderFns } from "./select_wei.vue?vue&type=template&id=5bcbab4d&scoped=true&"
import script from "./select_wei.vue?vue&type=script&lang=js&"
export * from "./select_wei.vue?vue&type=script&lang=js&"
import style0 from "./select_wei.vue?vue&type=style&index=0&id=5bcbab4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbab4d",
  null
  
)

export default component.exports